import * as React from "react";
import { Link, type LinkProps } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

export interface BottomNavItemProps {
  to: LinkProps["to"];
  icon: React.ReactNode;
  label: string;
  badge?: number;
  active?: boolean;
}

export function BottomNavItem({ to, icon, label, badge, active }: BottomNavItemProps) {
  return (
    <Link
      to={to}
      className={cn(
        "relative flex h-full flex-1 flex-col items-center justify-center gap-0.5",
        active ? "text-p-700" : "text-ink-500",
      )}
    >
      {active ? <span className="absolute inset-x-0 top-0 h-0.5 bg-p-600" /> : null}
      <span className="inline-flex size-5 items-center justify-center">{icon}</span>
      <span className="text-[10.5px]">{label}</span>
      {badge && badge > 0 ? (
        <span className="absolute right-1/4 top-1 inline-flex min-w-4 items-center justify-center rounded-full bg-vroom-red px-1 font-mono text-[9.5px] tabular-nums text-white ring-[1.5px] ring-surface">
          {badge > 99 ? "99+" : badge}
        </span>
      ) : null}
    </Link>
  );
}
